import { Col, Row } from 'antd';
import styles from "./styles/OrderClientInfo.module.css";
import React from 'react';

const OrderClientInfo = ({ id_user, orderType, address_info, branch }) => {
  return (
    <Row>
      <Col xs={24}>
        <div className={styles.clientCard}>
          <div className={styles.clientRow}>
            <div className={styles.clientCol}>
              <span className={styles.labelClient}>CLIENTE:</span>
              {`${id_user?.name ?? ''} ${id_user?.lastname ?? ''}`}
            </div>
            <div className={styles.clientCol}>
              <span className={styles.labelClient}>TELÉFONO:</span>
              {id_user?.phone && (
                <a href={`tel:${id_user.phone}`} className={styles.clientLink}>
                  {id_user.phone}
                </a>
              )}
            </div>
            {
              orderType == "1" ?
                <div className={styles.clientCol}>
                <span className={styles.labelClient}>TIENDA:</span>
                {branch.zone ?? ''}
              </div> :
              <div className={styles.clientCol}>
                <span className={styles.labelClient}>ZONA:</span>
                {address_info?.zone?.name ?? ''}
              </div>
            }
            
            <div className={styles.clientCol}>
              <span className={styles.labelClient}>EMAIL:</span>
              {id_user?.email?? ''}
            </div>
          </div>

          {
            orderType == "2" && (
              <div className={styles.clientRow}>
                {address_info?.latitude && (
                  <div className={styles.clientCol}>
                    <span className={styles.labelClient}>UBICACIÓN:</span>
                    <a
                      href={`https://maps.google.com/?z=19&q=${address_info.latitude},${address_info.longitude}`}
                      target="_blank"
                      rel="noreferrer"
                      className={styles.clientLink}
                    >
                      VER MAPA
                    </a>
                  </div>
                )}
                <div className={styles.clientCol}>
                  <span className={styles.labelClient}>DIRECCIÓN:</span>
                  {address_info?.address ?? ''}
                </div>
                <div className={styles.clientCol}>
                  <span className={styles.labelClient}>REFERENCIA:</span>
                  {address_info?.reference_point ?? ''}
                </div>
                <div className={styles.clientCol}>
                  <span className={styles.labelClient}>N° CASA:</span>
                  {address_info?.number ?? ''}
                </div>
              </div>
            )
          }


        </div>
      </Col>
    </Row>
  );
};

export default OrderClientInfo;
